(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["theme-scripts"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',event=>{const button=event.target.closest('[data-slider-button]');if(!button)return;const root=button.closest('[data-slider]');const track=root?.querySelector('[data-slider-track]');if(!track)return;const direction=button.dataset.sliderButton==='next'?1:-1;track.scrollBy({left:direction*track.clientWidth*.82,behavior:'smooth'})});

  (()=>{
    const reduceMotion=window.matchMedia('(prefers-reduced-motion: reduce)');
    const animatedSections=new WeakSet();
    const cardSelector='.ql-card,.ql-guide__card,.ql-search__edit,.ql-usp__item,.ql-reviews figure,.ql-faq details,.ql-product-tools__card';
    const mediaSelector='.ql-editorial-story__primary-media,.ql-editorial-story__secondary-media,.ql-guide__media,.ql-search__edit-media,.ql-product__media';
    const prepareSection=section=>{
      if(animatedSections.has(section))return;
      animatedSections.add(section);
      const top=section.getBoundingClientRect().top;
      if(reduceMotion.matches||top<window.innerHeight*.9){section.querySelectorAll('[data-ql-reveal]').forEach(element=>element.classList.add('is-revealed'));if(section.matches('[data-ql-reveal]'))section.classList.add('is-revealed');section.dataset.qlRevealComplete='true';return}
      const candidates=[];
      const add=(elements,type,start,step)=>elements.forEach((element,index)=>{
        if(element.closest(cardSelector)&&type!=='card')return;
        if(element.dataset.qlReveal)return;
        element.dataset.qlReveal=type;
        element.style.setProperty('--ql-reveal-delay',`${start+index*step}ms`);
        candidates.push(element)
      });
      add([...section.querySelectorAll('.ql-eyebrow,[class*="__eyebrow"]')],'text',0,35);
      add([...section.querySelectorAll('h1,h2')],'title',70,45);
      add([...section.querySelectorAll('.ql-lead,[class*="__intro"],[class*="__dek"],[class*="__description"]')],'text',140,40);
      add([...section.querySelectorAll(mediaSelector)].filter(element=>!element.closest(cardSelector)),'media',190,55);
      add([...section.querySelectorAll(cardSelector)],'card',240,75);
      if(!candidates.length){section.dataset.qlRevealComplete='true';return}
      section.dataset.qlRevealPrepared='true';
      observer.observe(section)
    };
    const reveal=section=>{
      section.querySelectorAll('[data-ql-reveal]').forEach(element=>element.classList.add('is-revealed'));
      section.dataset.qlRevealComplete='true';
      observer.unobserve(section)
    };
    const observer='IntersectionObserver'in window?new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting)reveal(entry.target)}),{rootMargin:'0px 0px -8% 0px',threshold:.08}):{observe:reveal,unobserve:()=>{}};
    const init=root=>{
      document.documentElement.classList.add('ql-motion-ready');
      const sections=root.matches?.('.shopify-section')?[root]:[...root.querySelectorAll('main .shopify-section,footer .shopify-section')];
      sections.forEach(prepareSection)
    };
    init(document);
    document.addEventListener('shopify:section:load',event=>init(event.target));
    reduceMotion.addEventListener('change',event=>{if(event.matches)document.querySelectorAll('[data-ql-reveal]').forEach(element=>element.classList.add('is-revealed'))})
  })();
  } catch(e) { console.error(e); }
})();

})();
